<script>
import ResultCheckbox from './ResultCheckbox'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  name: 'result-panel-constructor',
  props: ['result', 'resultsByReportId', 'displayShowDocument'],
  data () {
    return {
      bindSelected: false
    }
  },
  components: {
    ResultCheckbox
  },
  methods: {
    ...mapActions('documentForm', ['loadViewedDocument']),
    ...mapMutations('documentForm', ['setViewedDocumentDialog']),
    ...mapMutations('searchEnginePage', ['setResultCheckbox'])
  },
  computed: {
    ...mapState('documentForm', ['viewedDocumentDialog']),
    ...mapState('searchEnginePage', ['selectAllCheckbox', 'resultsCheckbox'])
  }
}
</script>
<style>
.result_card {
  margin-bottom: 5px;
}
.ais-highlight em {
 background-color: #FFF176;
}

.snippet em {
 background-color: #FFF176;
}

.chip {
    height: 23px;
    margin: 0px;
    margin-left: 2px;
    margin: 2.5px 2px;
    padding: 2px 4px;
}
.btn_icone {
  margin-right: 3px;
}

.source_img {
  margin-right: 8px;
  margin-top:5px;
  height:45px;
}
.source_img .v-image__image{
  background-position: right center!important;
}

.flag_icon {
   flex-basis: 5% !important;
   padding-top: 2px;
}

.result_title_star .v-input__control {
  width: 38px;
}

.bookmark_btn {
  border: none!important;
  height: 34px!important;
  width: 34px!important;
  margin: 0px;
  margin-bottom:4px;
  float:left;
}
</style>
